"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var Address = /*#__PURE__*/function () {
  function Address(buffer) {
    _classCallCheck(this, Address);

    this.buffer = buffer;

    if (buffer.length === 32) {
      if (!buffer.slice(0, 12).equals(Buffer.of(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0))) {
        throw new Error('Invalid address buffer.');
      } else {
        this.buffer = buffer.slice(12);
      }
    } else if (buffer.length !== 20) {
      throw new Error('Invalid address buffer.');
    }
  }

  _createClass(Address, [{
    key: "equals",
    value: function equals(rhs) {
      return this.buffer.equals(rhs.buffer);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }, {
    key: "toString",
    value: function toString() {
      return Address.toChecksumAddress(utils_1.bufferToHex(this.buffer));
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return this.buffer;
    }
  }, {
    key: "toBuffer32",
    value: function toBuffer32() {
      var buffer = Buffer.alloc(32);
      this.buffer.copy(buffer, 12);
      return buffer;
    }
  }], [{
    key: "fromString",
    value: function fromString(address) {
      if (!Address.isAddress(address)) {
        throw new Error("Invalid address string: ".concat(address));
      }

      return new Address(Buffer.from(address.replace(/^0x/i, ''), 'hex'));
    }
  }, {
    key: "isAddress",
    value: function isAddress(address) {
      if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        // Does not have the basic requirements of an address.
        return false;
      } else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) {
        // It's ALL lowercase or ALL upppercase.
        return true;
      } else {
        return Address.checkAddressChecksum(address);
      }
    }
  }, {
    key: "checkAddressChecksum",
    value: function checkAddressChecksum(address) {
      address = address.replace(/^0x/i, '');
      var addressHash = utils_1.sha3(address.toLowerCase()).replace(/^0x/i, '');

      for (var i = 0; i < 40; i++) {
        // The nth letter should be uppercase if the nth digit of casemap is 1.
        if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "toChecksumAddress",
    value: function toChecksumAddress(address) {
      if (!Address.isAddress(address)) {
        throw new Error('Invalid address string.');
      }

      address = address.toLowerCase().replace(/^0x/i, '');
      var addressHash = utils_1.sha3(address).replace(/^0x/i, '');
      var checksumAddress = '0x';

      for (var i = 0; i < address.length; i++) {
        // If ith character is 9 to f then make it uppercase.
        if (parseInt(addressHash[i], 16) > 7) {
          checksumAddress += address[i].toUpperCase();
        } else {
          checksumAddress += address[i];
        }
      }

      return checksumAddress;
    }
  }]);

  return Address;
}();

Address.ZERO = new Address(Buffer.alloc(20));
exports.Address = Address;